import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "vertical-lines-plus",
  "use": "vertical-lines-plus-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"vertical-lines-plus\">\n  <path fill-rule=\"evenodd\" d=\"M466,437h2v13h-2V437Zm4,0h2v13h-2V437Zm6,4h1v5h-1v-5Zm-2,2h5v1h-5v-1Z\" transform=\"translate(-466 -437)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/vertical-lines-plus.svg
// module id = null
// module chunks = 